export default __webpack_public_path__ + "static/media/wallCalendar.c79f2645.svg";